module.exports = __webpack_public_path__ + "img/close.0193d72a.svg";